'use client';

import Container from "../Container";
import Image from "next/image";

import imageSocial1 from "../../public/img/social_1.jpg";
import imageInstagram from "../../public/img/instagram.png";
import imageSocial2 from "../../public/img/social_2.jpg";
import { useEffect, useRef } from "react";
import { useTranslations } from 'next-intl';

const moveImages = (image1: HTMLElement | null, image2: HTMLElement | null) => {
    if (window && image1 && image2) {
        const scrollPosition = window.scrollY;
        const image1Multiplier = window.innerWidth >= 768 ? -0.08 : 0;
        const image2Multiplier = window.innerWidth >= 768 ? 0.08 : 0;
        image1.style.transform = `translateY(${scrollPosition * image1Multiplier}px)`;
        image2.style.transform = `translateY(${scrollPosition * image2Multiplier}px)`;
    }
};

export default function SectionInstagram() {
    const t = useTranslations('sections.instagram');

    const image1Ref = useRef<HTMLDivElement>(null);
    const image2Ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Skip the scroll-parallax for users who prefer reduced motion.
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const handleScroll = () => {
            moveImages(image1Ref.current, image2Ref.current);
        };

        if (image1Ref.current && !prefersReduced) {
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleScroll);
            handleScroll();
        }

        return () => {
            window.removeEventListener('resize', handleScroll);
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const handle = t('handle');
    const instagramLink = `https://www.instagram.com/${handle.substring(1)}/`;

    return (
        <Container className="relative">
            <div
                className="flex flex-col md:flex-row gap-8 justify-center items-center py-20 md:pt-36 md:pb-52 will-change-transform">
                <div className="w-full md:flex-1 max-w-[300px] relative -left-24 md:left-auto md:top-48"
                     ref={image1Ref}>
                    <a href={instagramLink}
                       target="_blank"
                       rel="nofollow noreferrer"
                       className="gtm-contact-click block w-full aspect-square relative transform transition-all duration-300 mouse-hover:-translate-y-2 mouse-hover:shadow-lg rounded-[45px]">
                        <Image src={imageSocial1}
                               placeholder="blur"
                               className="size-full rounded-[45px] object-cover"
                               sizes="(min-width: 768px) 300px, 100vw"
                               alt=""
                        />
                    </a>
                </div>

                <div className="flex-1 max-w-[300px]">
                    <a href={instagramLink}
                       target="_blank"
                       rel="nofollow noreferrer"
                       className="gtm-contact-click flex flex-col items-center gap-3"
                    >
                        <div className="w-14 md:w-24">
                            <Image src={imageInstagram} alt=""/>
                        </div>
                        <div
                            className="inline-flex flex-col items-center text-lg md:text-xl font-bold leading-[1.4] md:leading-[1.5] text-center">
                            {t('cta')}
                            <span className="text-gradient">{handle}</span>
                        </div>
                    </a>
                </div>

                <div
                    className="w-full md:flex-1 max-w-[300px] relative -right-24 md:right-auto md:-top-48 will-change-transform"
                    ref={image2Ref}>
                    <a href={instagramLink}
                       target="_blank"
                       rel="nofollow noreferrer"
                       className="gtm-contact-click block w-full aspect-square relative transform transition-all duration-300 mouse-hover:-translate-y-2 mouse-hover:shadow-lg rounded-[45px]">
                        <Image src={imageSocial2}
                               placeholder="blur"
                               className="size-full rounded-[45px] object-cover"
                               sizes="(min-width: 768px) 300px, 100vw"
                               alt=""
                        />
                    </a>
                </div>
            </div>
        </Container>
    )
}
